export const LS_SEARCH_KEY = `VSLY_DASHBOARD_SEARCH`;
export const LS_SEARCH_STORES_KEY = `VSLY_STORES_SEARCH`;
export const LS_SORT_STORES_KEY = `VSLY_ACCOUNTS_SORT`;
export const LS_FILTER_KEY = `VSLY_DASHBOARD_FILTER`;
